import React from "react";
import { useDispatch } from "react-redux";
import { removeProfile } from "../../redux/slices/profileSlices";

const Logout = ({ onLogout }) => {
  const dispatch = useDispatch();
  localStorage.clear();
  sessionStorage.clear();
  dispatch(removeProfile());
  onLogout();
  return <div>Logout</div>;
};

export default Logout;
